import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = Omit<ClientAccount, 'summary'>;

export const useGlossaries = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query glossaries($skipPagination: Boolean!) {
      clientAccount {
        allOrderableTargetLanguages {
          code
          name
        }
        glossaries(skipPagination: $skipPagination) {
          nodes {
            id
            languageCodes
            default
            name
            updatedAt
            glossaryTerms {
              nodesCount
            }
          }
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['glossaries'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables: { skipPagination: true }
        }
      })
  });
};
